"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const locutusRange = require('locutus/php/array/range');
function range(low, high, step) {
    return locutusRange(low, high, step);
}
exports.range = range;
